<template>
  <modal-wrapper :shown="shown" title="Upload new image" @close-modal="$emit('close-modal')">
    <p class="text-white">
      <strong>The maximum file size is 2MB and the maximum image dimensions are 2000x2000 pixels.</strong>
    </p>

    <input class="hidden" type="file" accept="image/*" ref="fileInput" @change="onFileChange($event)" />

    <div class="wrapper">
      <div class="button-wrapper">
        <button :disabled="processing" @click="$refs.fileInput.click()" class="actionButton">
          Select File
        </button>
      </div>
    </div>

    <modal-processing-indicator v-if="processing"></modal-processing-indicator>

    <div v-if="errorMessage" class="text-danger mt-5">
      <strong>{{ errorMessage }}</strong>
    </div>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '../../modal/ModalWrapper';
import ModalProcessingIndicator from '../../modal/ModalProcessingIndicator';
import {uploadGalleryImage} from '../../../utility/gallery/uploadGalleryImage';
import {validateGalleryImage} from '../../../utility/gallery/validateGalleryImage';

export default {
  name: 'add-email-domain-modal',
  components: {ModalWrapper, ModalProcessingIndicator},
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: null,
      processing: false,
    };
  },
  watch: {
    shown(shown, previousShown) {
      if (!shown && previousShown) {
        this.processing = false;
      }
    },
  },
  methods: {
    async onFileChange(event) {
      this.errorMessage = null;
      const [file] = event.target.files;

      this.processing = true;
      try {
        await validateGalleryImage(file);
        await this.uploadImage(file);
      } catch (error) {
        this.errorMessage = error.message;
      }
      this.processing = false;
    },
    async uploadImage(file) {
      try {
        const url = await uploadGalleryImage(file);
        this.$emit('close-modal');
        $.notify('Image has been uploaded.', 'success');
        window.location.reload();
      } catch (error) {
        const message = error.message || '';
        this.errorMessage = 'Failed to upload an image. ' + message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
